/**
 * Workaround for not being able to use the WYSIWYG editor's "Insert Link" form to link
 * to an internal page but include a query string. The link in the editor is setup as
 * an external link but with relative path, ex: /community/partners/?category=co-investors
 * SilverStripe will automatically prepend https:// so this will remove it
 */

export default {
  init: () => {
    document.querySelectorAll('.wysiwyg [href^="https:///"]').forEach((anchor) => {
      anchor.href = anchor.href.replace("https://", "");
    });
  },
};
